import { ContractDocument } from "../../classes/index";

const ContractDocumentModule = {
  namespaced: true,
  state: {
    contractDocuments: [],
    contractDocument: {}
  },
  actions: {
    getContractDocuments: async ({ dispatch, commit, rootGetter }, payload) => {
      try {
        const params = Object.assign({}, payload);
        const data = await ContractDocument.getContractDocuments(params);
        if (!payload.isRenewContract)
          commit("setContractDocuments", data);
        return data;
      } catch (e) {
        throw e;
      }
    },
    getContractDocument: async ({ dispatch, commit, rootGetter }, payload) => {
      try {
        const params = Object.assign({}, payload);
        const data = await ContractDocument.getContractDocument(params);
        if (!payload.isRenewContract)
          commit("setContractDocument", data);
        return data;
      } catch (e) {
        throw e;
      }
    },
    createContractDocument: async (
      { dispatch, commit, rootGetter },
      payload
    ) => {
      try {
        const params = Object.assign({}, payload);
        const data = await ContractDocument.createContractDocument(params);
        dispatch("getContractDocuments", { 
          contractId: params.contractId,
          areaInterestId: params.areaInterestId,
          contractCheckoutId: params.contractCheckoutId
        });
        return data;
      } catch (e) {
        throw e;
      }
    },
    createContractDocumentNoContract: async (
      { dispatch, commit, rootGetter },
      payload
    ) => {
      try {
        const params = Object.assign({}, payload);
        const data = await ContractDocument.createContractDocumentNoContract(params);
        commit("setContractDocument", data);
        return data;
      } catch (e) {
        throw e;
      }
    },
    updateContractDocument: async (
      { dispatch, commit, rootGetter },
      payload
    ) => {
      try {
        const params = Object.assign({ id: payload.objectId }, payload);
        const data = await ContractDocument.updateContractDocument(params);
        dispatch("getContractDocuments", { 
          contractId: params.contractId,
          areaInterestId: params.areaInterestId,
          contractCheckoutId: params.contractCheckoutId
        });
        return data;
      } catch (e) {
        throw e;
      }
    },
    removeContractDocument: async (
      { dispatch, commit, rootGetter },
      payload
    ) => {
      try {
        const params = Object.assign({ id: payload.objectId }, payload);
        const data = await ContractDocument.removeContractDocument(params);
        return data;
      } catch (e) {
        throw e;
      }
    },
    getContractDocumentByContractIds: async ({ dispatch, commit, rootGetter }, payload) => {
      try {
        const params = Object.assign({}, payload);
        const data = await ContractDocument.getContractDocumentByContractIds(params);
        if (!payload.isRenewContract)
          commit("setContractDocuments", data);
        return data;
      } catch (e) {
        throw e;
      }
    },
  },
  getters: {
    getContractDocument: state => {
      return state.contractDocument;
    },
    getContractDocuments: state => {
      return state.contractDocuments;
    }
  },
  mutations: {
    setContractDocument: (state, payload) => {
      state.contractDocument = payload;
    },
    setContractDocuments: (state, payload) => {
      state.contractDocuments = payload;
    }
  }
};

export default ContractDocumentModule;
